import isEmpty from 'lodash/isEmpty'
import type { DocumentNode } from 'graphql/language'
import { useDocument } from '@ztechapps/common.hook'
import { getMyStoreOrderQuery } from './graphql'

/**
 * This is a common function to query the order information
 * It contains full information that is commonly used even in checkout
 * use this accordingly as it will load heavy operation
 */
export const useOrder = ({ filter, sort, query }: { filter?: any; sort?: any; query?: DocumentNode }) => {
  return useDocument({
    query: query ?? getMyStoreOrderQuery,
    filter,
    sort,
    options: { queryOptions: { skip: isEmpty(filter) } },
  })
}
